import { LoggerService } from '../../common/common.module'

import { TASK_SERVICE_NAME, TaskService } from '../../../services/task'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

import { TaskCreateEditController } from './tasks-create-edit.directive.controller'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'

// #region Consts

import * as TEMPLATE from './tasks-create-edit.tpl.html'

// #endregion


// #region Setup

export class TaskCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = [$SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, 'logger', USER_SESSION_SERVICE_NAME, TASK_SERVICE_NAME, (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        userSessionService: UserSessionService,
        taskService: TaskService
    ) => new TaskCreateEditController(
        $scope,
        $q,
        $timeout,
        logger,
        userSessionService,
        taskService,
        TaskService.REFERENCE_TYPE,
        TaskService.SIMAX_MODULE_NAME
    )]

    template = TEMPLATE
}

// #endregion